import React from 'react';
import './index.scss';
import Header from './header';
import newToSellerFirst from '../../assets/icons/newToSellerFirst.svg';
import sellerSignUpBottomBackground from '../../assets/icons/sellerSignUpBottomBackground.svg';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useSendAndVerifyOtp } from './useSendAndVerifyOtp';
import { OtpController } from '../../components/formControllers/otp';
import Button from '../../components/button';
import { InputController } from '../../components/formControllers/input';
import { useAppDispatch } from '../../storeHook';
import { showAlert } from '../../services/alert';

type LoginFormData = {
  phoneNumber: string;
  otp: string;
};

export const OtpSignInPage: React.FC = () => {
  const {
    register,
    control,
    handleSubmit,
    getValues,
    formState: { isValid, errors },
  } = useForm<LoginFormData>({ mode: 'onTouched' });

  const { sendOtp, verifyOtp, isLoading, otpSent } =
    useSendAndVerifyOtp();
  const dispatch = useAppDispatch();

  const onSendOtp = (data: LoginFormData = getValues()) => {
    // logEvent(customEvents.USER_CLICKED_SEND_OTP);
    sendOtp(data.phoneNumber)
      .unwrap()
      .then((res) => {
        dispatch(showAlert({ content: res.message }));
      })
      .catch((err) => {
        console.log('send otp error', err);
        // this.utility.handleError(err)
      });
  };

  const onLoginClick = (data: LoginFormData) => {
    // logEvent(customEvents.USER_CLICKED_LOGIN);
    // this.spinner.showSpinner.emit(true);
    verifyOtp({
      otp: data.otp,
      mobile: data.phoneNumber,
      appType: 'SELLER',
    })
      .unwrap()
      .then(() => {
        dispatch(
          showAlert({ content: 'Login successfully' })
        );
      })
      .catch((err) => {
        console.log('login failed error', err);
        // this.utility.handleError(err)
      });
  };

  const logSignUpEvent = () => {};
  return (
    <div className="landing-container">
      <Header />
      <div className="form-page">
        <div className="form-container">
          <div className="login-text-header">
            Login to your seller account
          </div>
          <form
            className="otp-form"
            onSubmit={handleSubmit(
              otpSent ? onLoginClick : onSendOtp
            )}>
            {otpSent ? (
              <OtpController
                control={control}
                name="otp"
                phoneNumber={getValues('phoneNumber')}
              />
            ) : (
              <InputController
                register={register('phoneNumber', {
                  required: 'Phone Number is required.',
                  pattern: {
                    value: /^([6-9]{1})([0-9]{9})$/,
                    message: 'Phone Number is not valid.',
                  },
                })}
                autoComplete="on"
                error={errors?.phoneNumber?.message}
                label="Phone Number"
                type="tel"
                maxLength={10}
                autoFocus
                placeholder="Eg: 9999999999"
              />
            )}
            <div className="form-control">
              <Button
                disabled={!!(!isValid || isLoading)}
                className="action-btn">
                {otpSent ? 'Log In' : 'Send OTP'}
              </Button>
            </div>
          </form>
        </div>
        {otpSent ? (
          <div className="to-sign-up">
            Didn’t receive OTP?
            <a
              onClick={() => onSendOtp()}
              className="cursor-pointer">
              Resend
            </a>
          </div>
        ) : (
          <div className="to-sign-up">
            <img src={newToSellerFirst} />
            <Link onClick={logSignUpEvent} to="/sign-up">
              {'Sign Up >'}
            </Link>
          </div>
        )}
        <div
          className="background-bottom"
          style={{
            backgroundImage: `url(${sellerSignUpBottomBackground})`,
          }}></div>
      </div>
    </div>
  );
};
